import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Checkmark = (_0)=>{
    let { testId } = _0, props = _object_without_properties(_0, [
        "testId"
    ]);
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.86009 17.9999V17.9999C9.58292 17.9991 9.31856 17.8832 9.13009 17.6799L4.27009 12.5099H4.27009C3.89177 12.1068 3.91192 11.4733 4.31509 11.0949C4.71826 10.7166 5.35177 10.7368 5.73009 11.1399V11.1399L9.85009 15.5299L18.2601 6.32995V6.32995C18.6059 5.89933 19.2353 5.83057 19.6659 6.17638C20.0966 6.52219 20.1653 7.15161 19.8195 7.58223C19.7948 7.61301 19.7683 7.6423 19.7401 7.66994L10.6001 17.6699V17.6699C10.4134 17.8769 10.1488 17.9965 9.87009 17.9999L9.86009 17.9999Z"
        })
    }));
};
